// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__18nP8","bigColWidth":"Table_bigColWidth__2jZYt","biggerColWidth":"Table_biggerColWidth__2YxrQ","row":"Table_row__2vIHg","col":"Table_col__-3O4q"};